var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCautionYellow18 = function SvgLightIcnCautionYellow18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 9.7,
    fill: "#263238",
    rx: 3,
    ry: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FED200",
    fillRule: "evenodd",
    d: "M7.878 3.858a1.3 1.3 0 0 1 2.244 0l5.67 9.678a1.3 1.3 0 0 1-1.122 1.957H3.33a1.3 1.3 0 0 1-1.122-1.957zm.66 4.471.138 2.07q.04.403.13.6.09.195.322.196a.34.34 0 0 0 .328-.203q.099-.203.129-.584l.185-2.13q.03-.294.03-.58 0-.484-.125-.74Q9.551 6.7 9.18 6.7a.64.64 0 0 0-.493.201q-.187.2-.187.56 0 .263.039.868m.158 4.744q.195.17.458.17a.66.66 0 0 0 .452-.172.6.6 0 0 0 .194-.476.62.62 0 0 0-.192-.456.64.64 0 0 0-.462-.188.62.62 0 0 0-.459.188.62.62 0 0 0-.187.456q0 .307.196.478",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnCautionYellow18;